module.exports = __webpack_public_path__ + "static/media/client_2.18d87174.jpeg";